import React from 'react';
import { connect } from 'react-redux';

import * as Styled from './styles';
import { clearMessages } from 'features/shared/actions';

const Notification = ({ clearMessages, examplesMessage, authMessage }) => {
  let messages = [examplesMessage, authMessage];
  messages = messages.filter(message => {
    return message != null;
  });

  if (!messages.length) {
    return <></>;
  }

  return (
    <div>
      {messages.map(message => {
        return (
          <Styled.Notification type={message.type} onClick={clearMessages}>
            {message.text}
          </Styled.Notification>
        );
      })}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    examplesMessage: state.examples.message,
    authMessage: state.auth.message
  };
};

export default connect(mapStateToProps, { clearMessages })(Notification);
